import React, { useEffect } from "react";
import { Switch, Route, useHistory, useRouteMatch } from "react-router-dom";
import Index from "./index";
import fire from "../config/fire";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

const Register =() =>{
  const history = useHistory();
  let { path } = useRouteMatch();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    fire.auth().onAuthStateChanged((user) => {
        if (user && !isLoggedIn) {
            history.push("/login");
        }
    });
//     if (isLoggedIn)
//     {
//         history.push("admin/login")
//     }
// //     fire.auth().onAuthStateChanged((user) => {
// //       if (user) {
// //         if (!isLoggedIn) dispatch({ type: "SET_USER", payload: user });
// //         if (window.location.pathname === "/admin")
// //           history.push("/admin/dashboard");
// //         history.push(window.location.pathname);
// //       } else {
// //         history.push("/admin/login");
// //       }
// //     });
  }, [dispatch]);

    // register user
    const registerUser = ({ name, email, password, confirmPassword }) => {
        if (!name || !email || !password || !confirmPassword) {
        return toast.warning("Please fill in all fields!!");
        }

        if (password !== confirmPassword) {
        return toast.warning("Passwords donot match!");
        }

        fire
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then((user) => {
            const currentUser = fire.auth().currentUser;
            currentUser.updateProfile({
            displayName: name,
            });
            dispatch({ type: "SET_USER", payload: currentUser });
            history.push("/admin/dashboard");
        })
        .catch((err) => {
            if (err.code === "auth/email-already-in-use") {
            toast.error("User already exists");
            }
        });
    };
    return (
        <Switch>
          {/* <Route path={`/register`}>
            <Index registerUser={registerUser} />
          </Route> */}
        </Switch>
    );
}
export default Register;